// Layout seam for the /me shell (WP-1, contracts §4.2). MeShell branches ONLY
// its wrapper div on this: the existing onboarding/auth world keeps its
// byte-identical centered card, while the Homebase surfaces get the full-bleed
// rail with one wide column (desktop = one vertical column per the design).
// Task flows (check-in, reflection, both reschedule flows) are one-job forms, so they
// use the onboarding CARD, not the hub rail.
// Pure function so the mapping is unit-testable without rendering the shell.

export type MeLayoutVariant = "card" | "hub";

const HUB_PATH_PREFIXES = [
  "/me/home",
  "/me/sessions",
  "/me/reports",
];

// Task flows that live UNDER a hub prefix but take the card: offering new times for a
// session is a one-job form, like the check-in, not a page to browse.
const CARD_FLOW_PATTERNS = [/^\/me\/sessions\/[^/]+\/reschedule\/?$/];

export function getMeLayoutVariant(pathname: string): MeLayoutVariant {
  if (CARD_FLOW_PATTERNS.some((pattern) => pattern.test(pathname))) return "card";
  const isHub = HUB_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
  return isHub ? "hub" : "card";
}
